import api from "./api";

// Capa API del onboarding OAuth de Facebook/Instagram (0375 FB1-b, FSD).
export const getFacebookConfig = () => api.get("/facebook-onboarding/config");
export const listFacebookPages = (userToken) =>
  api.post("/facebook-onboarding/pages", { userToken });
export const connectFacebookPage = (payload) =>
  api.post("/facebook-onboarding/connect", payload);

// Embedded Signup de WhatsApp (Meta Cloud API, 0386): { code, wabaId, phoneNumberId } → crea la
// conexión provider="waba" (canjea el code por el business token en el backend). Reutiliza /config.
export const connectWaba = (payload) =>
  api.post("/waba-onboarding/connect", payload);

// Instagram Business Login oficial (0379 Plan B): devuelve la URL de instagram.com/oauth
// con el companyId firmado en el `state`. El frontend redirige el navegador a esa URL.
export const getInstagramAuthUrl = () =>
  api.get("/instagram-onboarding/authorize-url");
